/// <reference types="vite/client" />

type RuntimeEnv = 'production' | 'development' | 'preview' | 'local'

type RuntimeConfig = {
  env: RuntimeEnv
  apiBaseUrl: string
  oauthClientId: string
}

const PROD_API = 'https://api.gtowizard.com'
const DEV_API = 'https://api.dev.gtowizard.com'

// Public PKCE client ids — not secrets (they appear in the authorize URL).
// Hardcoding the per-env values lets a single build artifact serve local,
// preview, dev, and prod, mirroring rakeback-web's runtime-env.ts pattern.
const PROD_OAUTH_CLIENT_ID = 'SqNU8EQQ1Dt0C7e46ABvMurUp2s9cN9zezLZCgxa'
const DEV_OAUTH_CLIENT_ID = '8YsaPmbJUUEHlg3oqYkh5SaajApnFmd58hVGJTkB'

function classifyEnv(hostname: string): RuntimeEnv {
  if (hostname === 'affiliates.gtowizard.com') {
    return 'production'
  }
  if (hostname.endsWith('.dev.gtowizard.com')) {
    return 'development'
  }
  if (hostname.endsWith('.pages.dev')) {
    return 'preview'
  }
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'local'
  }

  return 'development'
}

export function getRuntimeConfig(): RuntimeConfig {
  if (typeof window === 'undefined') {
    return {
      env: 'development',
      apiBaseUrl: DEV_API,
      oauthClientId: DEV_OAUTH_CLIENT_ID,
    }
  }

  const env = classifyEnv(window.location.hostname)
  const isProd = env === 'production'

  const apiBaseUrl =
    typeof import.meta.env.VITE_PROXY_URL === 'string' && import.meta.env.VITE_PROXY_URL.length > 0
      ? '' // empty string signals proxy mode (requests go through dev server)
      : isProd
        ? PROD_API
        : DEV_API

  return {
    env,
    apiBaseUrl,
    oauthClientId: isProd ? PROD_OAUTH_CLIENT_ID : DEV_OAUTH_CLIENT_ID,
  }
}

export function isProdEnv(): boolean {
  return getRuntimeConfig().env === 'production'
}

export function isDevEnv(): boolean {
  const env = getRuntimeConfig().env === 'development' || getRuntimeConfig().env === 'preview'

  return env
}

export function isLocalEnv(): boolean {
  return getRuntimeConfig().env === 'local'
}
